import React from 'react'
import { Container } from 'react-bootstrap';
import "./InsightArticle.css";
import InsightMeta from '../InsightMeta/InsightMeta';
import { renderTextWithNormalDash } from '../../utils/textFormatters';
const InsightArticle = ({ insightData }) => {
    return (
        <>
            
        <section className="insight-article-section py-5">
                <Container>
                    <InsightMeta
                        author={insightData.author}
                        date={insightData.published_date}
                        readTime="6 min read"
                    />

                    {/* Blog Image */}
                    {insightData.insight_image && (
                        <div className="insight-article-image mb-4">
                            <img
                                src={insightData.insight_image}
                                alt={insightData.title}
                                className="img-fluid rounded-4"
                            />
                        </div>
                    )}

                    {/* Blog Content */}
                    <div className="insight-article-content text-white">
                        {insightData.insights_content.map((section, idx) => {
                            if (section.heading) {
                                return (
                                    <div key={idx}>
                                        <h5 className="section-heading">{renderTextWithNormalDash(section.heading)}</h5>
                                        <p>{renderTextWithNormalDash(section.paragraph)}</p>
                                        {section.list && (
                                            <ul>
                                                {section.list.map((item, i) => (
                                                    <li key={i}>{item}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                );
                            } else if (section.quote) {
                                return (
                                    <blockquote key={idx} className="insight-quote">
                                        {renderTextWithNormalDash(section.quote)}
                                    </blockquote>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </Container>
            </section></>
    )
}

export default InsightArticle